import React from 'react';

// Status pill in Enterprise Requisition's colours (MyRequisitions getStatusBg/getStatusCol): upper-case label,
// tinted background, coloured text and border. PO statuses ER has no match for get their own tint.
export const MPO_PILL = {
  draft:              { bg: '#fef9c3', col: '#ca8a04', label: 'DRAFT' },
  pending_approval:   { bg: '#ede9fe', col: '#7c3aed', label: 'PENDING APPROVAL' },
  on_hold:            { bg: '#fef3c7', col: '#b45309', label: 'ON HOLD' },
  returned:           { bg: '#ffedd5', col: '#f97316', label: 'RETURNED' },
  rejected:           { bg: '#fee2e2', col: '#ef4444', label: 'REJECTED' },
  approved:           { bg: '#dcfce7', col: '#16a34a', label: 'APPROVED' },
  issued:             { bg: '#dbeafe', col: '#1d4ed8', label: 'ISSUED' },
  partially_received: { bg: '#cffafe', col: '#0e7490', label: 'PARTIALLY RECEIVED' },
  fully_received:     { bg: '#ccfbf1', col: '#0f766e', label: 'FULLY RECEIVED' },
  cancelled:          { bg: '#f1f5f9', col: '#64748b', label: 'CANCELLED' },
  closed:             { bg: '#e2e8f0', col: '#334155', label: 'CLOSED' },
};

export default function MPOStatusPill({ status, onHold }) {
  const key = onHold && status === 'pending_approval' ? 'on_hold' : status;
  const s = MPO_PILL[key] || { bg: '#f1f5f9', col: '#64748b', label: String(status || '—').replace(/_/g, ' ').toUpperCase() };
  return (
    <span
      style={{
        background: s.bg, color: s.col, border: `1px solid ${s.col}40`,
        padding: '4px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700,
        display: 'inline-block', whiteSpace: 'nowrap',
      }}
    >
      {s.label}
    </span>
  );
}
